import {
  QueryParameters as DiscoverPageParametersV2,
  build as discoverProductsRequestV2,
} from "@faire/web-api/api/v2/search/products/discover/get";
import { match as matchDiscoverRoute } from "@faire/web-api/routes/discover/searchTerm/match";
import { getLocationOrThrow } from "@faire/web/common/globals/getLocation";
import { LocalizationStore } from "@faire/web/common/localization/LocalizationStore";
import { prefetch } from "@faire/web/common/requests/prefetch";
import {
  buildDiscoverProductsRequest,
  getPageNumberGivenRecordOfQueryParams,
  parseSearch,
} from "@faire/retailer-shared/search/searchRequest";

export const prefetchProducts = () => {
  const { pathname, search } = getLocationOrThrow();
  const request = getDiscoverRoutePrefetchesClientSide({
    pathname,
    query: search,
  });
  if (request) {
    prefetch(discoverProductsRequestV2(request));
  }
};

// made export just for tests
export const getDiscoverRoutePrefetchesClientSide = (params: {
  pathname: string;
  query: string;
}): DiscoverPageParametersV2 | undefined => {
  const discoverMatch = matchDiscoverRoute(params.pathname ?? "");

  const parsedSearch = parseSearch({
    search: params.query,
    discoverSearchTerm: discoverMatch?.params.searchTerm,
  });

  const pageNumber = getPageNumberGivenRecordOfQueryParams(parsedSearch);

  // Only prefetch for first page because the page_size field of the search request depends on the response from the banners API for other pages
  if (pageNumber !== 0) {
    return undefined;
  }

  return buildDiscoverProductsRequest({
    parsedSearch: parsedSearch,
    locale: LocalizationStore.get().locale,
    pageSize: undefined,
    filterSplitStrategy: undefined,
  });
};
